import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SubModule } from 'src/app/models/administration/sub-module';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { LocalStorageService, SessionService } from 'brainloper-ui';


@Component({
    selector: 'app-submenu',
    templateUrl: './submenu.component.html',
    styleUrls: ['./submenu.component.scss'],
    standalone: false
})
export class SubmenuComponent implements OnInit {

  public movil:boolean = false

  constructor(
    public dialogRef: MatDialogRef<SubmenuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubModule[],
    private router : Router,
    private session : SessionService,
    private storage : LocalStorageService,
    private utils: UtilsServiceService

  ) { }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
  }

  redirigir(destino){
    if(destino == "/mantenimiento/preoperacionales"){
      this.session.setData('redireccion','modal')
    }
      let url = this.utils.getQueryParams(destino)
          this.router.navigate([`${url.url}`],{
            queryParams: url.params
          })

      this.dialogRef.close()
  }



}

